var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-alert',{attrs:{"color":"warning","outlined":"","text":"","type":"info","dense":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }